const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

/* =========================================================
   Catedo - Skin visuel du bouton Shopify Inbox (APPARENCE uniquement).
   Inline ici (et non en asset separe) car Shopify versionne les assets
   via le hash ?v= : un asset charge par URL JS reste en cache (non fiable).
   Injecte du CSS + une icone premium dans le shadow DOM ouvert de l'app.
   Ne touche a aucun ecouteur, ni a l'ouverture du chat, ni au composant Inbox.
   Pour retirer : supprimer ce bloc + la regle anti-FOUC dans catedo-buttons.css.
   ========================================================= */
(function () {
  var ICON = '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="#C4955A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>'
    + '<path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/></svg>';

  var CSS = [
    'button.chat-toggle.chat-toggle.chat-toggle{',
      'width:52px !important;height:52px !important;',
      'min-width:52px !important;max-width:52px !important;min-height:52px !important;max-height:52px !important;padding:0 !important;',
      'border-radius:50% !important;background:#2C2925 !important;',
      'box-shadow:0 8px 20px rgba(0,0,0,.12) !important;',
      'display:flex !important;align-items:center !important;justify-content:center !important;gap:0 !important;',
    '}',
    '.chat-toggle [data-spec="button-text"]{display:none !important;}',
    '.chat-toggle svg[data-spec="button-icon"]{display:none !important;}',
    '.chat-toggle .catedo-chat-ico{display:flex !important;align-items:center;justify-content:center;width:30px !important;height:30px !important;}',
    '.chat-toggle .catedo-chat-ico svg{width:30px !important;height:30px !important;}',
    '.chat-notification.chat-notification{background:#6FA74F !important;color:#fff !important;}'
  ].join('');

  function apply() {
    var inner = document.querySelector('#shopify-chat inbox-online-store-chat')
             || document.querySelector('inbox-online-store-chat');
    if (!inner || !inner.shadowRoot) return false;
    var sr = inner.shadowRoot;
    var btn = sr.querySelector('.chat-toggle');
    if (!btn) return false;
    if (!sr.getElementById('catedo-inbox-skin')) {
      var st = document.createElement('style');
      st.id = 'catedo-inbox-skin'; st.textContent = CSS; sr.appendChild(st);
    }
    if (!btn.querySelector('.catedo-chat-ico')) {
      var sp = document.createElement('span');
      sp.className = 'catedo-chat-ico'; sp.innerHTML = ICON; btn.appendChild(sp);
    }
    inner.classList.add('catedo-ready');
    return true;
  }

  var observing = false;
  function tick() {
    if (apply()) {
      if (!observing) {
        try {
          var inner = document.querySelector('#shopify-chat inbox-online-store-chat')
                   || document.querySelector('inbox-online-store-chat');
          new MutationObserver(function () { apply(); }).observe(inner.shadowRoot, { childList: true, subtree: true });
          observing = true;
        } catch (e) {}
      }
      return true;
    }
    return false;
  }

  var n = 0, t = setInterval(function () { if (tick() || ++n > 120) clearInterval(t); }, 50);
  setTimeout(function () { try { var i = document.querySelector('inbox-online-store-chat'); if (i) i.classList.add('catedo-ready'); } catch (e) {} }, 4500);
})();
